<div class="loader">
  <span class="spinner spinner-inverse"></span>
</div>
